<template>
  <span
    class="whatsapp-badge"
    :class="{ 'whatsapp-badge--inverted': inverted }"
    :style="{ width: size + 'px', height: size + 'px' }"
  >
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      :style="{ width: glyphSize + 'px', height: glyphSize + 'px' }"
    >
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  </span>
</template>

<script>
// The WhatsApp mark as a WHITE glyph inside a filled brand-green disc.
//
// Why not the icons8-whatsapp-50.svg asset used on the message rows: that
// file is the full-colour mark -- a near-white handset on brand green -- so
// on any green or teal button it is green-on-green and effectively
// invisible. That was the owner's complaint, 2026-10-05. Putting the glyph
// on its own disc means the mark carries its own background and stays
// legible whatever the button under it does.
//
// An inline path rather than an image file, because it has to be recoloured
// (white on the disc), and because the two buttons that use it would
// otherwise each carry their own copy of the path.
//
// Presentation only, and aria-hidden: the buttons that use it have their own
// visible text label, so a second accessible name here would be read twice.
export default {
  name: 'WhatsAppBadgeIcon',
  props: {
    // Diameter of the disc, in px. Each caller sizes it to its own button.
    size: {
      type: Number,
      default: 26
    },
    // White disc with a green glyph, for buttons that are themselves brand
    // green (WhatsappChet) -- the default green disc would vanish into them.
    inverted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    glyphSize() {
      // The mark reads best at a little under 60% of the disc, which leaves
      // an even ring of green around it at every size the app uses.
      return Math.round(this.size * 0.58);
    }
  }
};
</script>

<style scoped>
/* px, never rem: this app sets html { font-size: 10px }. */
.whatsapp-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #25D366;
  flex-shrink: 0;
}

.whatsapp-badge svg {
  display: block;
  /* public/queries.css gives `a.trip-default-btn svg` a 5px margin-left on
     phones, which pushed the glyph off-centre in the disc. */
  margin: 0;
  fill: #ffffff;
}

.whatsapp-badge--inverted {
  background: #ffffff;
}

.whatsapp-badge--inverted svg {
  fill: #25D366;
}
</style>
